import { marked } from 'marked';

const renderer = new marked.Renderer();

renderer.link = (href: string, _, text: string) =>
    `<a target="_blank" href="${href}" title="${href}" onclick="event.stopPropagation()">${text}</a>`;

export default (string: string) => marked(string.replace(/\t/g, ''), { renderer });
